export type SupportedLocale = 'el' | 'en'

let runtimeTranslations: Record<string, string> = {}

export function normalizeLocale(locale?: string | null): SupportedLocale {
  return locale?.toLowerCase().startsWith('en') ? 'en' : 'el'
}

export function setRuntimeTranslations(translations: Record<string, string>) {
  runtimeTranslations = translations
}

export function localized(
  item: { name: string; nameEl?: string | null; translationKey?: string | null },
  locale: string = 'el',
) {
  const translatedName = item.translationKey ? runtimeTranslations[`${item.translationKey}.name`] : undefined
  if (translatedName) return translatedName

  return normalizeLocale(locale) === 'el' && item.nameEl ? item.nameEl : item.name
}

export function localizedDescription(
  item: { description?: string | null; descriptionEl?: string | null; translationKey?: string | null },
  locale: string = 'el',
) {
  const translatedDescription = item.translationKey ? runtimeTranslations[`${item.translationKey}.description`] : undefined
  if (translatedDescription) return translatedDescription

  return normalizeLocale(locale) === 'el' && item.descriptionEl ? item.descriptionEl : item.description
}
